import React, { Component } from "react";
import { trackPromise } from 'react-promise-tracker';
import { formatoSeparadorMiles, formatoSeparadorMilesValue, agregarBarra , normalizarMonto } from '../../generico/utils/FormatoInput'
import Popup from "react-popup";
import CabalTitulo from "./CabalTitulo"
import { habilitarInputSeleccionado } from "../../generico/utils/Tabla";
import history from "../login/history";
import ConfigService from "../../../services/configuracion/ConfigService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight, faMoneyCheckDollar } from "@fortawesome/free-solid-svg-icons";
import pagoServicioServiceV2 from "../../../services/pagoServicios/pagoServicioServiceV2";

export default class SicoopPaso2 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      buscar: undefined,
      datosCliente: [],
      // detalleCuotas: undefined,
      formularioUnico: [],
      cuotas: [],
      cabecera: [],
      label: "",
      detalleCuota: "NO",
      tipoTrx: undefined,
      disableSgte: true,
      numCuentaDestino:undefined,
      docDestinatario:undefined,
      montoTotal:undefined,
      paymentService:undefined,
      comision:undefined,
      buscando:false,
      itemSelected:undefined,
      parametrosMostrados:undefined,
      parametrosMostradosCopy:undefined,
      barraAgregada:false,
      // parametersFactura : []


    };


  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              history.push(ConfigService.getPathByName("pagoServicioCabal")?.url);
              window.location.reload();
            },
          },
        ],
      },
    });


  listarFacturas(){
    if( this.state.buscando === false ){
      this.setState({buscando:true});
    }else{
      return null
    }
    if (this.state.buscar === undefined) {
      let parameters = [];
      this.props.parametersResponse.forEach(element => {
        element = JSON.parse(JSON.stringify(element));
        if( element.fieldType !== 7 && element.fieldType !== '7' ){
          parameters.push(element);
        }
      });
      let data =  {
        'id' : this.props.idOperacion,
        'parameter': parameters
      }
      data = JSON.parse(JSON.stringify(data));
      trackPromise(
        pagoServicioServiceV2.listarFacturas(data)
        .then( response => {    
          // console.log('RESPONSE LISTAR FACTURAS');
          // console.log(response);
          let status = response.data.datos.header;
          if ( response.status !== 200 ){
            Popup.queue(this.notifiPopup("Error", 'Ha ocurrido algún error en el servicio de Listar Facturas, Por favor intente más tarde.'));
            this.previousStep.click();
          }else{
            if (status.codRespuesta !== "0") {
              Popup.queue(this.notifiPopup("Error", status.txtRespuesta));
              this.previousStep.click();
            }
          }
          let data = response.data.datos.data;
          let datoCliente = data.label;
          this.setState({datosCliente:datoCliente});
  
          let facturas = data.parameter;
          let cantidadFacturas = 0;
          if( facturas.length > 0 ){
            cantidadFacturas = facturas[facturas.length-1].invoiceGroup - facturas[0].invoiceGroup + 1;
          }
          let esGrilla = false;
          if( cantidadFacturas === 0 && facturas.length > 0 ){
            cantidadFacturas = 1;
          }
//**************************CANTIDA DE FACTURAS IGUAL A 1************************** */
          if( cantidadFacturas === 1 || cantidadFacturas === 0 ){
            esGrilla = false;
            let arrayFacturas = [];
            for (let index = 0; index < cantidadFacturas; index++) {
              arrayFacturas.push({
                campo : [],
                index : index
              });
            }
            
            let indice = 0;
            let indice2 = 0;
            for( let i = 0 ; i < facturas.length ; i++ ){
              if( facturas[i].invoiceGroup === indice + 1 ){
                arrayFacturas[indice].index = indice+1;
                arrayFacturas[indice].campo[indice2] = facturas[i];
                indice2++;
              }
              if( i !== facturas.length - 1 ){
                if( facturas[i].invoiceGroup !== facturas[i+1].invoiceGroup ){
                  indice++;
                  indice2 = 0;
                }
              }
            }
            let valores = JSON.parse(JSON.stringify(arrayFacturas[0].campo));
            // console.log({valores});
            let parameter = [];
            for( let i = 0 ; i < valores.length ; i++ ){
              let formatoOriginal = valores[i].format;
              valores[i].value = valores[i].value.trim();
              if( valores[i].isAccount === true ){
                this.setState({numCuentaDestino:valores[i].value});
              }
              if( valores[i].isDoc === true ){
                this.setState({docDestinatario:valores[i].value});
              }
              let esOption = false;
              if( valores[i].format === 'DATE' && !valores[i].value.includes('/') ){
                this.setState({barraAgregada: true});
                valores[i].value = agregarBarra(valores[i].value);
              }
              // if( (valores[i].format === 'MONEY' || valores[i].isAmount) && !valores[i].value.includes('.') ){
                // valores[i].value = formatoSeparadorMilesValue(valores[i].value);
              // }
              if( valores[i].type === 'OPTION' && valores[i].options !== null ){
                // valores[i].value = valores[i].options[0].name;
                esOption = true;
                let option = JSON.parse(valores[i].options);
                valores[i].value = option[0].name;
              }
              if( esOption ){
                let option = JSON.parse(valores[i].options);
                parameter.push({
                  name: valores[i].name,
                  label : valores[i].label,
                  value: option[0].value,
                  fieldType:  valores[i].fieldType,
                  notificationOrder: valores[i].notificationOrder,
                  format : formatoOriginal
                });
              }else{
                parameter.push({
                  name: valores[i].name,
                  label : valores[i].label,
                  value: valores[i].value,
                  fieldType:  valores[i].fieldType,
                  notificationOrder: valores[i].notificationOrder,
                  format : formatoOriginal
                });
              }

            }
            // this.state.paymentService = parameters;
            this.setState({ formularioUnico: valores,paymentService : parameter });
            this.setState({ detalleCuota: "NO", esGrilla: esGrilla,
            tipoTrx: data.tipoTrx, buscar: this.props.buscar,
            valorMonto: undefined,disableSgte: false });
          }else if( cantidadFacturas > 1 ){
//**************************CANTIDAD DE FACTURAS MAYOR QUE 1**************************
            esGrilla = true;
            let arrayFacturas = [];
            for (let index = 0; index < cantidadFacturas; index++) {
              arrayFacturas.push({
                campo : [],
                index : index
              });
            }
            
            let indice = 0;
            let indice2 = 0;
            for( let i = 0 ; i < facturas.length ; i++ ){
              if( facturas[i].invoiceGroup === indice + 1 ){
                arrayFacturas[indice].index = indice+1;
                arrayFacturas[indice].campo[indice2] = facturas[i];
                indice2++;
              }
              if( i !== facturas.length - 1 ){
                if( facturas[i].invoiceGroup !== facturas[i+1].invoiceGroup ){
                  indice++;
                  indice2 = 0;
                }
              }
            }
            let detCuotas = [];
            let detCuotasCopy = [];
            let detCabecera = []; 
              for (let i = 0; i < arrayFacturas.length; i++) {
                let detalle = JSON.parse(JSON.stringify(arrayFacturas[i]));
                let detalleCopy = JSON.parse(JSON.stringify(arrayFacturas[i]));

                // console.log({detalle});
                for (let c = 0; c < detalle.campo.length; c++) {
                  // let esOption = false;
                  let campoActual = detalle.campo[c];
                  let campoActualCopy = JSON.parse(JSON.stringify(detalle.campo[c]));
                  if (campoActual.format === "DATE" &&  !campoActual.value.includes("/")) {
                    campoActual.value = agregarBarra(campoActual.value);
                    this.setState({barraAgregada:true});
                  }
                  if ((campoActual.format === "MONEY" || campoActual.isAmount === true  ) &&  !campoActual.value.includes(".")) {
                    // campoActual.value = formatoSeparadorMilesValue(campoActual.value);
                    campoActualCopy.value = formatoSeparadorMilesValue(campoActual.value);
                    // let valorCopy = formatoSeparadorMilesValue(campoActual.value);
                  }
                  //TODO CAMBIAR EN EL CASO DE QUE LAS FACTURAS SEAN MAYOR QUE UNO
                  if (campoActual.type === "OPTION" &&  campoActual.options !== null) {
                    let option = JSON.parse(campoActual.options);
                    campoActual.value = option[0].name;
                  }
                  detalleCopy.campo[c] =  (campoActual.format === "MONEY" || campoActual.isAmount === true) ?
                                          campoActualCopy 
                                          : 
                                          campoActual;
                  detalle.campo[c] = campoActual;
                  // console.log({campoActual});
                }
                let indCab = 0;
                detCuotas.push(detalle);
                detCuotasCopy.push(detalleCopy);
                for (let a = 0; a < detalle.campo.length; a++) {
                  let detCampo = JSON.parse(JSON.stringify(detalle.campo[a]))
                  detCabecera[indCab] = detCampo.label;
                  indCab++
                }
              }

              this.setState({ datosCliente: datoCliente,
                parametrosMostrados : detCuotas,
                parametrosMostradosCopy:detCuotasCopy,
                label: null, cuotas: arrayFacturas, 
                cabecera: detCabecera, detalleCuota: "NO", 
                esGrilla: esGrilla, tipoTrx: data.tipoTrx, 
                valorMonto: undefined,
                disableSgte:false,
                buscar : this.props.buscar
              });
          }
        })
        .catch( error =>{
          Popup.queue(this.notifiPopup("Error", 'Error: '+error));
          console.log('Error Listar Facturas');
          console.log(error);
          this.previousStep.click();
        })
      );

    }
  }


  quitarPuntos(cadena){
    return cadena.replace(/\./g, '');
  }

  handleChange = (e,element) => {
    // console.log(e.target.value);
    let auxArray = this.state.paymentService;
    for( let i = 0 ; i < this.state.paymentService.length ; i++ ){
      if( this.state.paymentService[i].name === element.name ){
        const montoNormalizado = normalizarMonto(e.target.value);
        // let monto = (typeof e.target.value === "string") ? e.target.value.replaceAll(".","") : e.target.value;
        auxArray[i].value = montoNormalizado;
        // this.state.paymentService[i].value = e.target.value;
        if( element.isAmount ){
          // const montoTotal = (typeof e.target.value === "string") ? e.target.value.replaceAll(".","") : e.target.value;
          this.setState({montoTotal:montoNormalizado});
        }
        break;
      }
    }
    this.setState({paymentService : auxArray});
  };

  volver = (e) => {
    
    if (!this.state.esGrilla) {
      this.previousStep.click(); 
    }
    else{
      if (this.state.itemSelected === undefined) { 
        this.previousStep.click();
      }
      if(this.state.detalleCuota === "NO" || this.state.detalleCuota === undefined){
        this.previousStep.click();
      }
      else{
        this.setState({ itemSelected: undefined, detalleCuota: "NO" });

      }
    
    }
  }

  seleccionFilaTabla = (e, item) => {
    habilitarInputSeleccionado(e + "_input");
    const radio = document.getElementById(e + "_radio");
    radio.checked = true;

    let _montoTotal;
    let parameters = [];
    let _numCuentaDestino = undefined;
    let _docDestinatario = undefined;

    item.campo.forEach(element => {
      if (element.isAccount === true) {
        _numCuentaDestino = element.value;
      }
      if (element.isDoc === true) {
        _docDestinatario = element.value;
      }

      if (element.isAmount === true || element.format === "MONEY") {
        _montoTotal = parseInt(normalizarMonto(element.value));
        parameters.push({ ...element, value: normalizarMonto(element.value) });
      } else if (element.type === 'OPTION') {
        const option = JSON.parse(element.options);
        parameters.push({ ...element, value: option[0].value });
      } else {
        parameters.push({ ...element });
      }
    });

    const newState = {
      paymentService: parameters,
      itemSelected: item.campo,
      disableSgte: false,
      montoTotal: _montoTotal,
    };
    if (_numCuentaDestino !== undefined) newState.numCuentaDestino = _numCuentaDestino;
    if (_docDestinatario !== undefined) newState.docDestinatario = _docDestinatario;

    this.setState(newState);
  };

  mostrarDetalles() {
    //TODO EN CASO DE QUE SEA OPTIONS, RENDERIZAR COMPONENTE "OptionInput"
    var tieneDetalle = this.state.detalleCuota;
    if (this.state.esGrilla) {
      if (tieneDetalle === "SI") {
        var aux = this.state.itemSelected
        
        return (
          <form id="det">
              <div className="col-md-12">
                <div className="row justify-content-md-center">
                  <div className="col-md-8" style={{border: "1px solid #e5e5e5", borderRadius: 10, padding: 30}}>
                    {aux.map(elemento =>
                      <div className="form-group">
                        <label className="input-label">{elemento.label}</label>
                        <input type="text" className="form-control input-box" name={elemento.name} 
                          // onKeyUp={formatoSeparadorMiles} defaultValue={formatoSeparadorMilesValue(elemento.value)}
                          placeholder={elemento.label} disabled={elemento.editable === false ? true : false}
                          onChange={(e) => { this.handleChange(e,elemento) }}
                        />
                      </div>
                    )}
                  </div>  
                </div>
              </div>           
          </form>
        );
      }
      else{
        let formulario = this.state.parametrosMostradosCopy;
        return (
          <table className="table" id='cuotas'>
            <thead>
              <tr>
                <th></th>
                {this.state.cabecera.map((element, key) =>
                  <th id={key+"_row"}>{element}</th>
                )}               
              </tr>
            </thead>

            <tbody key={"tBodyFormulariounico"}>
              {formulario.map((item, key) => (
                <tr id={key+"_row"} key={item.index} className="pago-servicio-registro-tabla">
                  <td onClick={(e) => { this.seleccionFilaTabla(key, item) }}><input type="radio" id={key + "_radio"} className="radioCuota" name="cuota" /></td>
                  {item.campo.map(element =>
                      <td onClick={(e) => { this.seleccionFilaTabla(key, item) }}>
                        {
                          (element.editable === true)
                          ?
                            <input type="text" id={key+"_input"} disabled="true" 
                            // onKeyUp={formatoSeparadorMiles} 
                            defaultValue={element.value}
                            onBlur={(e) => { this.handleChange(e,element) }}
                            // onChange={(e)=>{ this.handleChange(e,element) }}
                            // onBlur={ this.handleChange(element) }
                            />
                          :
                            element.value
                        }
                      </td>
                  )}              
                </tr>
              ))}
            </tbody>
          </table>
        );
      }
    }
    else {
      var formulario = [];
      for (var i = 0; i < this.state.formularioUnico.length; i++) {
        var datoCampo = this.state.formularioUnico[i];
        if (datoCampo.format === "DATE" &&  !datoCampo.value.includes("/")) {
        
          datoCampo.value = agregarBarra(datoCampo.value);
          this.setState({barraAgregada:true});
        }
        if (datoCampo.format === "MONEY" || datoCampo.isAmount === true) {
          if( this.state.montoTotal === undefined ){
            let montoTotal = (typeof datoCampo.value === "string") ? datoCampo.value.replaceAll(".","") : datoCampo.value;
            this.setState({montoTotal : normalizarMonto(montoTotal)});
          }
            // this.state.montoTotal = datoCampo.value;
          if(datoCampo.value.indexOf(".")<0){
            datoCampo.value = formatoSeparadorMilesValue(datoCampo.value);
          }
            
        }
        formulario.push(datoCampo);
      }

      return (
        <form id="formulario">
            <div className="col-md-12">
              <div className="row justify-content-md-center">
                <div className="col-md-8">
                  {formulario.map(elem =>
                    <div className="form-group">
                      <label className="input-label">{elem.label}</label>
                      <input type="text" className="form-control input-box" name={elem.name} onKeyUp={formatoSeparadorMiles}
                        placeholder={elem.label} defaultValue={elem.value} disabled={elem.editable === false ? true : false}
                        onBlur={(e) => { this.handleChange(e,elem) }}
                      />
                    </div>
                  )}  
                </div>
              </div>
            </div> 
        </form>
      );
    }
  }

  controlSeleccion(){
    if (!this.state.esGrilla){
      return false;
    }
    var validacion = false;
    if(!document.querySelector('input[name="cuota"]:checked')) {
        Popup.queue(this.notifiPopup("Error", 'Debe Seleccionar al Menos una Cuota para Continuar'));
        validacion = true;
    }
    
    return validacion
  }


  validatePagar = (e) => {
    var aux = [];
    // this.setState({buscar:undefined});
    this.state.buscar = undefined;
    if( this.state.buscar === undefined ){
      //// control radiobutton seleccionado
      if(this.controlSeleccion()===true){
        return
      }
      let monto=0;
      // let editable = false;
      if (this.state.esGrilla) {
        aux = this.state.itemSelected;
        if (this.state.valorMonto !== undefined) {
          // editable = true;
          for (var i = 0; i < aux.length; i++) {
            if (aux[i].isAmount === "true" || aux[i].isAmount === true) {
              aux[i].value=this.state.valorMonto;
              monto = this.state.valorMonto;
            }
          }
        }else{
          monto = this.state.montoTotal;
        }
      } else {
        aux = this.state.formularioUnico;
        if (this.state.valorMonto !== undefined) {
          for (var j = 0; j < aux.length; j++) {
            if (aux[j].isAmount === "true" || aux[j].isAmount === true) {
              aux[j].value=this.state.valorMonto;
              monto = this.state.valorMonto;
            }
          }
        }else{
          monto = this.state.montoTotal;
        }
      }
      //TODO QUITAR LOS CAMPOS OBTENIDOS DEL WS LISTAR PARAMETROS
      let parameters = [];
      this.props.parametersResponse.forEach(element => {
        element = JSON.parse(JSON.stringify(element));
        if( element.fieldType !== 7 && element.fieldType !== '7' ){
          parameters.push(element);
        }
      });
      if( this.props.network === 'INFONET' ){

        let comision;
        let data = {
          id : this.props.idOperacion,
          amount : monto,
          parameter : parameters
        }
        trackPromise(pagoServicioServiceV2.obtenerComision(data))
        .then( response =>{
          if( response.status === 200 ){
            if( response.data.datos.header.codRespuesta === '0' ){
              comision = response.data.datos.data.commission;
              this.setState({comision:parseInt(comision)});
              let nuevo = true;
              this.props.parametersResponse.forEach(element =>{
                nuevo = true;
                for( let i = 0 ; i < this.state.paymentService.length ; i++ ){
                  if( 
                    element.name === this.state.paymentService[i].name &&
                    element.fieldType === this.state.paymentService[i].fieldType
                  ){
                    nuevo = false;
                  }
                  if( this.state.paymentService[i].isAmount === true || this.state.paymentService[i].format === 'MONEY' ){
                    this.state.paymentService[i].value = normalizarMonto(this.state.paymentService[i].value);
                  }
                }
                if( nuevo && element.fieldType === 7 ){
                  this.state.paymentService.push({
                    name : element.name,
                    label : element.label,
                    value : element.value,
                    fieldType: element.fieldType ,
                    notificationOrder : element.notificationOrder
                  });
                }
              });
              this.props.respuestaPaso2(
                this.state.itemSelected,
                this.state.comision,
                this.state.paymentService,
                this.state.docDestinatario,
                monto,
                JSON.parse(JSON.stringify(aux)), 
                // this.state.tipoTrx, 
                // this.state.esGrilla, 
                // this.state.codigoServicio,
                this.state.datosCliente,
                this.state.numCuentaDestino,
                this.state.barraAgregada
              );
              this.setState({buscar:this.props.buscar});
              this.setState({ msgError: "", detalleCuota: undefined});
              this.lastStep.click();
            }else{
              Popup.queue(this.notifiPopup("ERROR",response.data.datos.header.txtRespuesta));
              this.setState({buscar:this.props.buscar});
              return;
            }
          }else{
            Popup.queue(this.notifiPopup("ERROR",'Ha ocurrido algún error al obtener la comisión, por favor intente más tarde.'));
            this.setState({buscar:this.props.buscar});
            return;
          }
          this.setState({buscar:this.props.buscar});
        })
        .catch( err=>{
          console.log(err);
          Popup.queue(this.notifiPopup("ERROR",'Ha ocurrido algún error en el servicio de Obtener Comisión, por favor intente más tarde.'));
          this.setState({buscar:this.props.buscar});
          return
        })
        
      }else{
        
        let nuevo = true;
        this.props.parametersResponse.forEach(element =>{
          nuevo = true;
          for( let i = 0 ; i < this.state.paymentService.length ; i++ ){
            if( 
              element.name === this.state.paymentService[i].name && 
              element.fieldType === this.state.paymentService[i].fieldType 
            ){
              nuevo = false;
            }
            // console.log(normalizarMonto(this.state.paymentService[i]));
            if( this.state.paymentService[i].isAmount === true || this.state.paymentService[i].isAmount === 'true' ){
              this.state.paymentService[i].value = normalizarMonto(this.state.paymentService[i].value);
            }
          }
          if( nuevo ){
            this.state.paymentService.push({
              name : element.name,
              label : element.label,
              value : element.value,
              fieldType: element.fieldType ,
              notificationOrder : element.notificationOrder
            });

          }
        });
        // console.log('PAYMENT SERVICE');
        // console.log(this.state.paymentService);
        this.props.respuestaPaso2(
          this.state.itemSelected,
          0,
          this.state.paymentService,
          this.state.docDestinatario,
          monto,
          JSON.parse(JSON.stringify(aux)), 
          // this.state.tipoTrx, 
          // this.state.esGrilla, 
          // this.state.codigoServicio, 
          this.state.datosCliente,
          this.state.numCuentaDestino,
          this.state.barraAgregada
        );
        // this.setState({buscar:this.props.buscar});
        this.setState({buscar:this.props.buscar , msgError: "", detalleCuota: undefined});
        this.lastStep.click();
        
      }
    }

  };


  volverPagoServicio = (e) => {
    history.push(ConfigService.getPathByName("pagoServicioCabal")?.url);
    window.location.reload();
  }
  
 
  render() {
    // console.log({BUSCAR:this.state.buscar});
    if (this.props.currentStep !== 2) { // Prop: The current step
      return null;
    }
    if (this.props.currentStep === 2) {
      // this.detalles();
      if( this.state.buscar === undefined )
        this.listarFacturas();
    }

    return (

      <div>
        {/******************* CABECERA WIZARD ***********************/}
        <div className="row">
          <div className="steps clearfix" style={{marginBottom:5}}>
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">{this.props.nombre}</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text">Consulta</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Cuenta</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <CabalTitulo img={this.props.img} empresa={this.props.empresa} />
        <hr/>

        {/******************* LOGICA PASOS ***********************/}
        <div className="row">
          <div className="col-md-12">
            {
              <div className="row">
                <div className="col-8">
                  <p style={{ marginBottom: 0 }}>
                    {this.state.datosCliente.name}
                  </p>
                  <p>{this.state.datosCliente.value}</p>
                </div>
              </div>
            }
            
            
            <div className="row">
              <div className="col-md-12">
                <div className="table-responsive">
                  {this.mostrarDetalles()}
                </div>
              </div>
            </div>
          </div>

        </div>
        <hr />
        <div className="row">
        <div className="col-md-4 btn-consulta">
          <button className="btn btn-cu-secundary" onClick={this.volverPagoServicio}><FontAwesomeIcon icon={faMoneyCheckDollar} /> Pagar Otro Servicio</button> 
          </div>
        <div className="col-md-4 btn-consulta">
          <button className="btn btn-cu-quintary" onClick={this.volver} ><FontAwesomeIcon icon={faArrowLeft} /> Volver</button>
        </div>
          <div className="col-md-4">
          <button className="btn btn-cu-primary"  onClick={this.validatePagar} disabled={this.state.disableSgte} >Continuar  <FontAwesomeIcon icon={faArrowRight} /></button>
          </div>
          
        </div>
        <button
          hidden
          ref={(a) => (this.lastStep = a)}
          className="btn btn-cu-primary"
          onClick={this.props.nextStep}

        ></button>
        <button
          hidden
          ref={(a) => (this.previousStep = a)}
          className="btn btn-cu-primary"
          onClick={this.props.previousStep}

        ></button>

      </div>

    );
  }




}